<template>
  <div id="applayout">
    <v-navigation-drawer v-model="drawer" app clipped>
      <v-list dense>
        <template v-for="item in items">
          <v-list-item :key="item.name" :to="{ name: item.name }">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-list-group prepend-icon="fas fa-globe">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Materials</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
            v-for="item in materialItems"
            :key="item.text"
            :to="{ name: item.name }"
          >
            <v-list-item-action>
              <v-icon small>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title v-text="item.text" />
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-group prepend-icon="fas fa-dolly">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Shipping</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="item in shippingItems"
            :key="item.text"
            :to="{ name: item.name }"
          >
            <v-list-item-action>
              <v-icon small>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title v-text="item.text" />
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar color="primary" app dark class="elevation-1" clipped-left>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title class="primary pr-5">
        HERMES
      </v-toolbar-title>
      <v-spacer />
      <v-menu bottom left v-if="currentUser">
        <template v-slot:activator="{ on }">
          <v-btn icon dark v-on="on">
            <v-icon>far fa-user</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-avatar>
              <v-icon>fas fa-user-tie</v-icon>
            </v-list-item-avatar>
            <v-list-item-title class="text-uppercase">
              {{ currentUser.user.username }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-btn color="primary" @click="logOut">
                Logout
              </v-btn>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  name: "TheAppBar",
  data() {
    return {
      drawer: false,
      items: [
        { icon: "fas fa-project-diagram", text: "Projects", name: "ProjectsListView" },
        { icon: "fas fa-cogs", text: "Tools", name: "Tools" },
        { icon: "fas fa-heartbeat", text: "Quality", name: "Quality" },
        { icon: "fas fa-gem", text: "Zenkit", name: "ZenkitHome"}
      ],
      materialItems: [
        { icon: "fas fa-database", text: "Database", name: "Materials" },
        { icon: "mdi-routes-clock", text: "Incoming", name: "IncomingMaterialsListView"}
      ],
      shippingItems: [
        { icon: "fas fa-truck", text: "Shipments", name: "Shipping" },
        { icon: "fas fa-boxes", text: "Inventory", name: "ShippingInventory" },
        {
          icon: "fas fa-shield-alt",
          text: "PicoShield",
          name: "ShippingPicoShield"
        }
      ]
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  methods: {
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push({ name: 'Login' });
    }
  }
};
</script>

